import React from 'react';
import Main from '../layouts/Main';
import Head from 'next/head';
import { CANONICAL_DOMAIN } from '../utils/constants';
import { Typography, Link as MUILink } from '@mui/material';
import CalendarImage from '../../public/assets/calendar-header.jpg';
import * as eventAjax from '../ajax/events';
import type { Event } from '@fosterburg/common-ui/types/Event';
import { useAjax } from '@fosterburg/common-ui/hooks/useAjax';
import EventCard from '../components/EventCard';
import Link from 'next/link';

export default function Events() {
  const [events, getEvents, getEventsMeta] = useAjax<Event[]>(eventAjax.getEvents, [], true);

  React.useEffect(() => {
    getEvents();
  }, []);

  return (
    <Main header_title="See What's Happening at Fosterburg!" background_image={CalendarImage}>
      <Head>
        <title>Fosterburg Baptist Church | Events</title>
        <meta property="og:title" content="Fosterburg Baptist Church | Events" key="title" />
        <link rel="canonical" href={`${CANONICAL_DOMAIN}/events`} />
      </Head>
      <div style={{ margin: 15, marginTop: 50, textAlign: 'center' }}>
        <Typography variant="h6">
          You can also view our full calendar{' '}
          <MUILink
            href="https://outlook.office365.com/calendar/published/4d27eee1d9514ed690afa77d7c7a40cf@fosterburg.org/17541a21546844848323c7511574fdce14570984791787605852/calendar.html"
            referrerPolicy="no-referrer"
            target="_blank"
          >
            here
          </MUILink>
          .
        </Typography>
      </div>
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        <div style={{ margin: 25 }}>
          {getEventsMeta.success && events.length == 0 ? (
            <Typography variant="h5">No current events. Please check back soon!</Typography>
          ) : (
            events.map((event) => (
              <div key={event.id} style={{ marginBottom: 25 }}>
                <EventCard title={event.name} date={new Date(event.date)} description={event.description} href={event.info_url} />
              </div>
            ))
          )}
        </div>
      </div>
    </Main>
  );
}
